<template>
    <div class="bandeja60-66">
        <!-- IMAGES -->

        <!-- soporte -->
        <!-- <img class="img66" :src="require('@/assets/images/gamas/66/soporte_horizontal.png')" /> -->

        <!-- Dimensiones -->
        <div class="portico60-bandeja66-dimensiones" v-if="mainElement.dimensiones_bandeja_porticos.value">
            {{ mainElement.dimensiones_bandeja_porticos.value.parts[0].num_value }}x{{
                mainElement.dimensiones_bandeja_porticos.value.parts[1].num_value }}
        </div>

        <!-- bandeja -->
        <img :src="require('@/assets/images/gamas/60/bandeja66.png')"
            :style="{ width: width + 'px', height: height + 'px' }"/>

    </div>
</template>
<script>
import { app } from "../../../application.js";
export default {
    name: "bandeja66",
    props: {
        mainElement: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            app: app,
        }
    },
    computed: {
        // isMobile() {
        //     return this.app.isMobile;
        // },
        width(){
            let default_width = 150;

            if( this.mainElement.dimensiones_bandeja_porticos.value){
                default_width = this.mainElement.dimensiones_bandeja_porticos.value.parts[1].num_value
            }

            return default_width * 0.5
        },
        height(){
            let default_height = 60;

            if( this.mainElement.dimensiones_bandeja_porticos.value){
                default_height = this.mainElement.dimensiones_bandeja_porticos.value.parts[0].num_value
            }

            return default_height * 0.5
        }
    },
    mounted() {
    }
}
</script>
<style>
.bandeja60-66 img {
    display: inline-block;
    /* justify-content: center;
    align-items: center; */
    height: auto;
    /* width: 100px; */
}
</style>